"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bibbiena": {
    "c4ea6337": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "skipSearch": false
    }],
    "candolesi": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "404025f0": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "skipSearch": false
    }],
    "gello": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9b44fd4f": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "skipSearch": false
    }],
    "giona-gressa": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c3d6043": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "skipSearch": false
    }],
    "lonnano": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "245b08dd": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-bifolco": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b416c666": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "skipSearch": false
    }],
    "querceto": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a6623eb": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "skipSearch": false
    }],
    "valchiusa": [{
      "hkey": "2984410b",
      "slug": "bibbiena",
      "name": "Bibbiena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;